import{m as o}from"./chunk-HBP5N4FR.js";o();var e=`.dapp-core-component__styles__operation-block {
  display: flex;
  align-items: center;
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__direction {
  text-transform: uppercase;
  line-height: 1;
  min-width: 2.5rem;
  display: flex;
  align-items: center;
  padding: 0.25em 0.4em;
  margin-right: 0.5rem;
  justify-content: center;
  font-size: 63%;
  margin-right: 0.5rem;
  position: relative;
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
  background-color: #f5f5f5;
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__direction.dapp-core-component__styles__in {
  color: #17c671;
  border: 1px solid rgba(23, 198, 113, 0.2);
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__direction.dapp-core-component__styles__out {
  color: #d39e00;
  border: 1px solid rgba(211, 158, 0, 0.2);
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__direction.dapp-core-component__styles__int {
  color: #cacbcc;
  border: 1px solid rgba(202, 203, 204, 0.2);
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__direction.dapp-core-component__styles__self {
  color: #6c757d;
  border: 1px solid rgba(108, 117, 125, 0.2);
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__explorer {
  align-items: flex-end;
  flex: 1;
  overflow: hidden;
  margin: 0;
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__explorer:hover {
  text-decoration: none;
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__explorer span {
  max-width: none;
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__explorer span [class*=left] span,
.dapp-core-component__styles__operation-block .dapp-core-component__styles__explorer span [class*=right] span {
  font-size: 1rem;
  color: #1f43f4;
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__explorer span:last-child {
  color: #1f43f4;
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__copy {
  margin-left: 0.5rem;
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__copy svg path {
  fill: #cacbcc;
  transition: all 200ms;
}
.dapp-core-component__styles__operation-block .dapp-core-component__styles__copy svg path:hover {
  fill: #1f43f4;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(e));var n={"operation-block":"dapp-core-component__styles__operation-block",operationBlock:"dapp-core-component__styles__operation-block",direction:"dapp-core-component__styles__direction",in:"dapp-core-component__styles__in",out:"dapp-core-component__styles__out",int:"dapp-core-component__styles__int",self:"dapp-core-component__styles__self",explorer:"dapp-core-component__styles__explorer",copy:"dapp-core-component__styles__copy"};export{e as a,n as b};
//# sourceMappingURL=chunk-2LAIOIHX.js.map
